import React from 'react';
import welcomeImg from '../../assets/welcome.webp';

const formatDate = () => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date().toLocaleDateString(undefined, options);
};

const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) {
        return 'Good Morning';
    } else if (hour < 18) {
        return 'Good Afternoon';
    } else {
        return 'Good Evening';
    }
};

const WelcomeCard = () => {
    const date = formatDate();
    const greeting = getGreeting();

    return (
        <div className="mb-4 px-12 py-5 bg-gradient-to-r from-[#2f9bd6] to-[#7cc9f3] rounded-md">
            <div className="grid md:grid-cols-2 grid-cols-1 gap-2 items-center w-full">
                <div>
                    <p className="mt-2 text-white">{date}</p>
                    <h1 className="text-xl font-semibold text-white tracking-wider">
                        {greeting},<br /> Welcome to BBSR Services
                    </h1>
                    <div className="mt-2 text-stone-200 tracking-wide">
                        <p>
                            Plot No-587/588, Antaryami Niwas, Ground Floor Mahaveer Nagar,
                            Garage Chhak, Lewis Rd, Samantarapur, Bhubaneswar, Odisha 751002
                        </p>
                    </div>
                </div>

                <div className="md:flex hidden justify-end">
                    <img
                        alt='welcome'
                        src={welcomeImg}
                        className="w-auto h-56 rounded-md"
                    />
                </div>
            </div>
        </div>
    );
};

export default WelcomeCard;